import { updateSessionId, setPendingMessage, addChatMessage } from '../actions/ucmaActions';
import { ChatMessageType } from '../store/schema/ChatMessageViewState';
import ChatViewState from '../store/schema/ChatViewState';
import getMySipUri from '../presenceManager/getMySipUri';
import sendChatMessage from '../services/sendChatMessage';

export default function(chat: ChatViewState) {
    const { sessionId, participants, pendingMessage, subject } = chat;

    if (pendingMessage) {
        sendChatMessage(sessionId, participants, pendingMessage, subject).then(newSessionId => {
            if (newSessionId != sessionId) {
                updateSessionId(chat, newSessionId);
            }
        });

        addChatMessage(chat, ChatMessageType.InstantMessage, getMySipUri(), chat.pendingMessage);

        setPendingMessage(chat, '');
    }
}
